import React, { useState } from 'react';
import './LicensePlateSelector.css';
import { plateFormats } from '../utils/plateFormats.js';

const LicensePlateSelector = ({ onSelect, selected }) => {
  const [format] = useState('classic');
  const handleSelect = (formatId) => {
  const selectedFormat = plateFormats.find(f => f.id === formatId);
  onSelect(selectedFormat); // ✅ Ez már a teljes formátum objektum
  };
  
  return (
    <div className="plate-selector">
      {format && <img src={format.image} alt={format.label} />}
      {plateFormats.map((format) => (
        <div
          key={format?.id}
          className={`plate-option ${selected === format?.id ? 'selected' : ''}`}
          onClick={() => handleSelect(format?.id)}
        >
          <img src={format.image} alt={format?.label} className="plate-image" />
          <span className="plate-label">{format?.label}</span>
        </div>
      ))}
    </div>
  );
};

export default LicensePlateSelector;
